import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { ApiService } from '../../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private headersCache$: Observable<any> | null = null;

  constructor(private apiService: ApiService) {}

  getHeaders(): Observable<any> {
    if (!this.headersCache$) {
      this.headersCache$ = this.apiService
        .get('menu/headers')
        .pipe(shareReplay(1));
    }
    return this.headersCache$;
  }

  getNotifications(customerId: number, page: number = 1) {
    const endpoint = `customer/notifications/${customerId}`;
    return this.apiService.get(endpoint, { page: page }, true);
  }
}
